<!--
    REV-22476 (Part 3) — the Jahresabschluss overview, after the AWF prototype: a centred column with a
    timeline of six steps, each with its status dot (done teal, open amber, nothing to measure grey,
    not there yet dashed), its title and its content.
-->
<div class="ov" data-testid="closing-overview" [class.ov--waiting]="waiting" [attr.data-waiting]="waiting">
    <header class="ov__head">
        <div class="ov__heading">
            <h2 class="ov__title">{{ 'abcp.overview.title' | i18next : { year: year ?? '' } }}</h2>
            <p class="ov__subtitle">{{ 'abcp.overview.subtitle' | i18next }}</p>
        </div>
        <ham-button
            variant="white"
            size="sm"
            lucideIcon="settings"
            data-testid="overview-settings"
            (buttonClick)="settings.emit()"
        >
            {{ 'abcp_settings_open' | i18next }}
        </ham-button>
    </header>

    <ol class="ov__steps">
        <!-- 1 · Stammdaten prüfen -->
        <li class="ov__step" data-testid="overview-step-master-data" [attr.data-state]="circleOf(1)">
            <ng-container *ngTemplateOutlet="rail; context: { state: circleOf(1) }"></ng-container>
            <div class="ov__body">
                <div class="ov__step-head">
                    <div class="ov__step-heading">
                        <h3 class="ov__step-title">1 · {{ 'abcp.overview.masterData.title' | i18next }}</h3>
                        <p class="ov__step-text">{{ 'abcp.overview.masterData.text' | i18next }}</p>
                    </div>
                </div>
                <div class="ov__card">
                    <div class="ov__row" data-testid="overview-chart-of-accounts">
                        <ng-container
                            *ngTemplateOutlet="dot; context: { state: overview?.chartOfAccounts?.state ?? 'none' }"
                        ></ng-container>
                        <div class="ov__row-main">
                            <span class="ov__row-title">{{ 'abcp.chartOfAccounts.title' | i18next }}</span>
                            <span
                                class="ov__row-sub"
                                *ngIf="!overview?.importing && overview?.chartOfAccounts as chart"
                            >
                                {{
                                    chart.withoutPosition > 0
                                        ? ('abcp.overview.masterData.withoutPosition'
                                          | i18next : { count: chart.withoutPosition })
                                        : ('abcp.overview.masterData.complete' | i18next)
                                }}
                            </span>
                            <span
                                class="ov__row-sub ov__row-sub--warn"
                                data-testid="overview-without-function"
                                *ngIf="overview?.chartOfAccounts?.withoutFunction?.length"
                                [hamTooltip]="accountsLine(overview!.chartOfAccounts.withoutFunction)"
                                tooltipClass="abcp"
                                [tooltipOnlyWhenTruncated]="true"
                            >
                                {{
                                    'abcp.overview.masterData.withoutFunction'
                                        | i18next : { count: overview!.chartOfAccounts.withoutFunction.length }
                                }}
                                {{ accountsLine(overview!.chartOfAccounts.withoutFunction) }}
                            </span>
                        </div>
                        <span
                            class="ov__open"
                            [hamTooltip]="waiting ? ('abcp.setup.import.locked' | i18next) : ''"
                            tooltipClass="abcp"
                        >
                            <ham-button
                                variant="white"
                                size="sm"
                                data-testid="overview-open-chart-of-accounts"
                                [disabled]="waiting"
                                (buttonClick)="open.emit('chartOfAccounts')"
                            >
                                {{ 'abcp.overview.open' | i18next }}
                            </ham-button>
                        </span>
                    </div>
                    <div class="ov__row ov__row--soon">
                        <ng-container *ngTemplateOutlet="dot; context: { state: 'soon' }"></ng-container>
                        <div class="ov__row-main">
                            <span class="ov__row-title">{{ 'abcp.overview.masterData.mandateContext' | i18next }}</span>
                            <span class="ov__row-sub">{{
                                'abcp.overview.masterData.mandateContextText' | i18next
                            }}</span>
                        </div>
                        <ng-container *ngTemplateOutlet="soon"></ng-container>
                    </div>
                </div>
            </div>
        </li>

        <!-- 2 · Eröffnungsanalyse — coming soon -->
        <li class="ov__step" data-testid="overview-step-opening" data-state="soon">
            <ng-container *ngTemplateOutlet="rail; context: { state: 'soon' }"></ng-container>
            <div class="ov__body">
                <div class="ov__step-head">
                    <div class="ov__step-heading">
                        <h3 class="ov__step-title">
                            2 · {{ 'abcp.overview.opening.title' | i18next }}
                            <ng-container *ngTemplateOutlet="soon"></ng-container>
                        </h3>
                        <p class="ov__step-text">{{ 'abcp.overview.opening.text' | i18next }}</p>
                    </div>
                </div>
                <div class="ov__card">
                    <div class="ov__row ov__row--soon" *ngFor="let check of openingChecks">
                        <ng-container *ngTemplateOutlet="dot; context: { state: 'soon' }"></ng-container>
                        <div class="ov__row-main">
                            <span class="ov__row-title">{{ 'abcp.overview.opening.' + check | i18next }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </li>

        <!-- 3 · Dokumente zuordnen -->
        <li class="ov__step" data-testid="overview-step-documents" [attr.data-state]="circleOf(3)">
            <ng-container *ngTemplateOutlet="rail; context: { state: circleOf(3) }"></ng-container>
            <div class="ov__body">
                <div class="ov__step-head">
                    <div class="ov__step-heading">
                        <h3 class="ov__step-title">3 · {{ 'abcp.overview.documents.title' | i18next }}</h3>
                        <p class="ov__step-text">{{ 'abcp.overview.documents.text' | i18next }}</p>
                    </div>
                    <ng-container
                        *ngTemplateOutlet="
                            openButton;
                            context: { target: 'documents', key: 'abcp.overview.documents.open' }
                        "
                    ></ng-container>
                </div>
                <div class="ov__card">
                    <div
                        class="ov__row"
                        data-testid="overview-missing-proof"
                        *ngFor="let row of overview?.documents?.missing ?? []; trackBy: trackByFunction"
                        [attr.data-function]="row.accountFunction"
                    >
                        <lucide-icon
                            class="ov__missing-icon"
                            name="file-exclamation-point"
                            [size]="17"
                            aria-hidden="true"
                        ></lucide-icon>
                        <div class="ov__row-main">
                            <span class="ov__row-title">
                                {{
                                    'abcp.overview.documents.missing'
                                        | i18next : { kinds: kindsText(row.proofLabels, 'abcp.overview.or' | i18next) }
                                }}
                            </span>
                            <span
                                class="ov__row-sub"
                                [hamTooltip]="accountsLine(row.accounts)"
                                tooltipClass="abcp"
                                [tooltipOnlyWhenTruncated]="true"
                                >{{ accountsLine(row.accounts) }}</span
                            >
                        </div>
                        <span class="ov__count">{{
                            'abcp.overview.accounts' | i18next : { count: row.accounts.length }
                        }}</span>
                    </div>
                    <div
                        class="ov__empty"
                        *ngIf="!loading && !overview?.importing && (overview?.documents?.missing?.length ?? 0) === 0"
                    >
                        {{
                            (overview?.documents?.waitingForChartOfAccounts
                                ? 'abcp.overview.documents.waiting'
                                : 'abcp.overview.documents.none'
                            ) | i18next
                        }}
                    </div>
                </div>
            </div>
        </li>

        <!-- 4 · Bilanzkonten abstimmen -->
        <li class="ov__step" data-testid="overview-step-balance-sheet" [attr.data-state]="circleOf(4)">
            <ng-container *ngTemplateOutlet="rail; context: { state: circleOf(4) }"></ng-container>
            <div class="ov__body">
                <div class="ov__step-head">
                    <div class="ov__step-heading">
                        <h3 class="ov__step-title">4 · {{ 'abcp.overview.balanceSheet.title' | i18next }}</h3>
                        <p class="ov__step-text">{{ 'abcp.overview.balanceSheet.text' | i18next }}</p>
                    </div>
                    <ng-container
                        *ngTemplateOutlet="
                            openButton;
                            context: { target: 'balanceSheet', key: 'abcp.overview.balanceSheet.open' }
                        "
                    ></ng-container>
                </div>
                <div class="ov__card">
                    <div class="ov__grid ov__grid--head">
                        <span>{{ 'abcp.overview.balanceSheet.position' | i18next }}</span>
                        <span class="ov__num">{{ 'abcp.overview.balanceSheet.balance' | i18next }}</span>
                        <span class="ov__num">{{ 'abcp.overview.balanceSheet.reconciled' | i18next }}</span>
                        <span></span>
                    </div>
                    <button
                        type="button"
                        class="ov__grid ov__position"
                        data-testid="overview-position"
                        *ngFor="let row of overview?.balanceSheet?.positions ?? []; trackBy: trackByPosition"
                        [attr.data-position]="row.position"
                        [attr.aria-disabled]="blocked"
                        [class.is-locked]="blocked"
                        [hamTooltip]="blocked ? (lockReasonKey | i18next) : ''"
                        tooltipClass="abcp"
                        (click)="onPosition(row.position)"
                    >
                        <span class="ov__position-label">
                            <abcp-status-pie
                                data-testid="overview-position-status"
                                [counts]="row.statusCounts"
                            ></abcp-status-pie>
                            <span class="ov__position-name">{{ row.label }}</span>
                        </span>
                        <span class="ov__num">{{ amount(row.balance) }}</span>
                        <span class="ov__num">{{ row.reconciled }} / {{ row.total }}</span>
                        <lucide-icon
                            class="ov__chevron"
                            name="chevron-right"
                            [size]="15"
                            aria-hidden="true"
                        ></lucide-icon>
                    </button>
                    <div class="ov__empty" *ngIf="!loading && (overview?.balanceSheet?.positions?.length ?? 0) === 0">
                        {{ 'abcp.overview.balanceSheet.none' | i18next }}
                    </div>
                </div>
            </div>
        </li>

        <!-- 5 · Erfolgsrechnung plausibilisieren — the page only, no figure yet -->
        <li class="ov__step" data-testid="overview-step-income-statement" data-state="none">
            <ng-container *ngTemplateOutlet="rail; context: { state: 'none' }"></ng-container>
            <div class="ov__body">
                <div class="ov__step-head">
                    <div class="ov__step-heading">
                        <h3 class="ov__step-title">5 · {{ 'abcp.overview.incomeStatement.title' | i18next }}</h3>
                        <p class="ov__step-text">{{ 'abcp.overview.incomeStatement.text' | i18next }}</p>
                    </div>
                    <ng-container
                        *ngTemplateOutlet="
                            openButton;
                            context: { target: 'incomeStatement', key: 'abcp.overview.incomeStatement.open' }
                        "
                    ></ng-container>
                </div>
            </div>
        </li>

        <!-- 6 · Abschluss — heading only -->
        <li class="ov__step ov__step--last" data-testid="overview-step-closing" data-state="soon">
            <ng-container *ngTemplateOutlet="rail; context: { state: 'soon' }"></ng-container>
            <div class="ov__body">
                <div class="ov__step-head">
                    <div class="ov__step-heading">
                        <h3 class="ov__step-title">
                            6 · {{ 'abcp.overview.closing.title' | i18next }}
                            <ng-container *ngTemplateOutlet="soon"></ng-container>
                        </h3>
                    </div>
                </div>
            </div>
        </li>
    </ol>
</div>

<!-- The step's rail: the large status dot and the line down to the next step. -->
<ng-template #rail let-state="state">
    <div class="ov__rail" [attr.data-state]="state">
        <ng-container *ngTemplateOutlet="dot; context: { state: state, large: true }"></ng-container>
    </div>
</ng-template>

<ng-template #dot let-state="state" let-large="large">
    <span class="ov__dot" [class.ov__dot--large]="large" [attr.data-state]="state" aria-hidden="true">
        <lucide-icon *ngIf="state === 'done'" name="check" [size]="large ? 11 : 8" [strokeWidth]="3"></lucide-icon>
    </span>
</ng-template>

<ng-template #soon>
    <span class="ov__soon" data-testid="overview-soon">{{ 'abcp.overview.soon' | i18next }}</span>
</ng-template>

<!-- A button into the closing workspace: disabled while the accounting data is still loading or the
     Kontenplan is not complete. -->
<ng-template #openButton let-target="target" let-key="key">
    <span class="ov__open" [hamTooltip]="blocked ? (lockReasonKey | i18next) : ''" tooltipClass="abcp">
        <ham-button variant="white" size="sm" [disabled]="blocked" (buttonClick)="open.emit(target)">
            {{ key | i18next }}
        </ham-button>
    </span>
</ng-template>
